// @flow
import React from 'react'
import I18n from 'i18n-react'
import { humanizer } from 'devx-js-utilities'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypePrice = (props: ColumnTypeDefaultProps) => {
  let value = I18n.texts && I18n.texts.general.notContain ? I18n.translate('general.notContain') : ''
  if (props.data && typeof props.data !== 'object') {
    if (Number.isInteger(props.data)) {
      value = `${humanizer.csNumber(props.data)} ${I18n.translate('general.currency')}`
    } else {
      value = props.data
    }
  }
  return ([
    <span
      className='mobile-label d-lg-none w-100 pl-3'
      key={`quote-insuranceCompany-price-name-${props.columnConfig.key}-${props.quote.id}`}
    >
      {I18n.translate(`quoteColumn.${props.columnConfig.key}`)}
    </span>,
    <strong
      className='text-nowrap pr-3 pr-lg-0 text-right text-lg-left'
      key={`quote-insuranceCompany-price-${props.columnConfig.key}-${props.quote.id}`}
    >
      {value}
    </strong>
  ])
}

export default ColumnTypePrice
